<!-- eslint-disable -->
<template lang="pug">
    grade-form(:grade="grade" :submit="create")
        template(slot="title") {{ $i18n.t('grade.grade_create_title') }}
        template(slot="button") {{ $i18n.t('grade.grade_create_button') }}
</template>

<script>
    /*eslint-disable*/
    import GradeForm from './Form.vue'
    import GradeApi from '../../api/grade'
    import SchoolApi from '../../api/school'
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                grade: {
                    name: '',
                    status: 'active',
                    school: '',
                    location: null,
                    teachers: [],
                    course: '',
                    startDate: '',
                    endDate: '',
                    timetable: [
                        {
                            day: null,
                            time: ''
                        }
                    ]
                }
            }
        },
        watch: {
            authUser: {
                handler: function (user) {
                    if (user && user.school) {
                        SchoolApi.show(user.school.id).then((school) => {
                            if (school.isBillingActive ? school.account.status : true) {
                                this.grade.school = school;
                            }
                        });
                    }
                },
                immediate: true
            }
        },
        mounted() {
            if (!this.$can('addItem', 'grade')) {
                this.$router.push({ name: '403' });
            }
        },
        methods: {
            create(grade) {
                return GradeApi.create(grade)
                .then(data => {
                    return data;
                });
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user,
            })
        },
        components: {
            GradeForm
        }
    }
</script>
